export type AppleLogoProps = {
  disabled?: boolean;
};

export const AppleLogo = ({ disabled }: AppleLogoProps) => (
  <svg width={24} height={24} fill="none" xmlns="http://www.w3.org/2000/svg">
    <title>apple logo</title>
    <path
      d="M19 16.143c-.635-.195-1.206-.649-1.701-1.363a4.148 4.148 0 0 1-.743-2.412c0-.822.236-1.569.7-2.24.258-.378.667-.8 1.227-1.276-.366-.454-.743-.822-1.12-1.082-.667-.465-1.245-.732-2.107-.732-.804 0-2.441.808-3.618.808-1.13 0-2.199-.692-3.363-.692-1.238 0-2.25.52-3.058 1.558C4.409 9.76 4 11.102 4 12.757c0 1.774.538 3.58 1.583 5.441C6.649 20.058 7.715 21 8.824 21c.355 0 .83-.119 1.421-.368.582-.238 1.099-.357 1.53-.357.441 0 .99.108 1.626.346.646.228 1.141.347 1.507.347.915 0 1.842-.704 2.768-2.12.624-.942 1.055-1.85 1.324-2.705ZM14.951 3.454c0-.075-.01-.14-.01-.216-.011-.065-.033-.14-.054-.238-1.25.292-2.154.822-2.693 1.601-.538.779-.936 1.367-.958 2.437.791-.067 2.01-.403 2.412-.807.402-.404.776-.765.99-1.306.206-.53.313-1.027.313-1.47Z"
      fill={disabled ? '#D5D6DA' : '#000000'}
    />
  </svg>
);
